import { colors } from "../../theme";
import { BRAND_COLORS, brandRgba } from "../../utils/brandAssets";

export const homeSectionPaper = {
  backgroundColor: colors.paper,
  border: `1px solid ${colors.border}`,
  borderRadius: 2,
  overflow: "hidden",
};

export const homeCardHover = {
  cursor: "pointer",
  transition: "border-color 0.2s ease, background-color 0.2s ease",
  "&:hover": {
    borderColor: brandRgba(BRAND_COLORS.cyan, 0.4),
    backgroundColor: "rgba(255, 255, 255, 0.03)",
  },
};

export const horizontalScroll = {
  display: "flex",
  gap: 1.5,
  overflowX: "auto",
  pb: 0.5,
  mx: -0.5,
  px: 0.5,
  scrollbarWidth: "thin",
  "&::-webkit-scrollbar": { height: 6 },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: colors.border,
    borderRadius: 3,
  },
};
